
import Vue from "vue";
import { FormsAndSurveyServices } from "@/services";
import config from "@/config";
import { emitter, NotificationType } from "@/composables/emitter";
import { BIconEmojiNeutralFill } from "bootstrap-vue";
export default Vue.extend({
  data() {
    return {
      surveys: [] as { _id: string, name: string}[],
      surveyId: "",
      thumbnailFile: undefined as any,
      themeName: "",
    };
  },
  computed: {
    validAddTheme(): boolean {
      return this.themeName && this.surveyId && this.thumbnailFile ? true : false;
    },
  },
  methods: {
    async getAllSurveyThemes() {
      try {
        const allSurveys = await FormsAndSurveyServices.getAllSurveysForThemes({
          locationId: config.themeLocation,
          limit: 50
        });
        this.surveys = allSurveys.data.surveys;
      } catch (error) {
        console.error(error);
      }
    },
    async addSurveyThemes() {
      try {
        const bodyThemeData = new FormData();
        bodyThemeData.append("themeName", this.themeName);
        bodyThemeData.append("thumbnail", this.thumbnailFile);
        bodyThemeData.append("surveyId", this.surveyId);
        const result = await FormsAndSurveyServices.createSurveys(bodyThemeData);
        if (result.status === 201) {
          this.resetInput()
        }
      } catch (error: any) {
        console.error(error);
        emitter.$emit("notification", {
          title: "Add Failed",
          message: error.response?.data?.message || error,
          type: NotificationType.ERROR,
        });
      }
    },
    readThumbnailChange(e: any) {
      const filesAdded = [];
      const element = <HTMLInputElement>e.target;
      if (!element.files) return;
      this.thumbnailFile = element.files[0];
    },
    resetInput(){
      this.themeName = "";
      this.surveyId = "";
      this.thumbnailFile = undefined;
      const data = this.$refs.thumbnailUpload as HTMLInputElement;
      data.value  = '';
    }
  },
  async mounted() {
    await this.getAllSurveyThemes();
  },
});
